export default __webpack_public_path__ + "static/media/pic86.ae4404f9.jpg";